import { render } from "./MainGiaoDucVaYTe.vue?vue&type=template&id=0917f778&scoped=true"
import script from "./MainGiaoDucVaYTe.vue?vue&type=script&lang=js"
export * from "./MainGiaoDucVaYTe.vue?vue&type=script&lang=js"

import "./MainGiaoDucVaYTe.vue?vue&type=style&index=0&id=0917f778&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0917f778"]])

export default __exports__